<template>
  <div class="d-block simple-search-result" id="nav-search-results">
    <b-card class="shadow-none" style="min-width: 20rem border-0">
      <p class="m-3" v-if="!articleDisplayResults?.length" data-cy="article-not-found-warning">
        {{ $t("noArticleSearchResults") }}
      </p>
      <b-table
        borderless
        hover
        :items="articleDisplayResults"
        @row-clicked="selected"
        :fields="fields"
        selectable
        select-mode="single"
        thead-class="d-none"
        tbody-tr-class="simple-search-result-tr"
        ref="searchResultsDisplay"
        data-cy="search-article-result-tbl">
        <template #cell(displaytext)="data">
          <searchRow
            :articleId="data.item.articleId"
            :articleNo="data.item.articleNo"
            :class="{
              'highlight-row': data.item.articleId == highlightArticleId
            }"
            :Name="data.item.Name"
            :Description="data.item.Description"
            :searchPhrases="searchPhrases"
            :language="language" />
        </template>
      </b-table>
      <hr class="m-0" />
      <div class="rightP" v-if="articleDisplayResults?.length">
        <pager
          width="130px"
          onlySingleSteps
          :isOnFirstPage="actPage <= 0"
          :currentPage="actPage + 1"
          :isOnLastPage="lastPage"
          :isLoading="loading"
          @next-page="emits('navigate-next')"
          @prev-page="emits('navigate-previous')"
          data-cy="article-search-result-pager"></pager>
      </div>
    </b-card>
  </div>
</template>

<script setup lang="ts">
import Pager from "@common/components/Pager.vue";
import _ from "lodash";
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import searchRow from "@common/components/SimpleSearchResultRow.vue";

//#region General
const $route = useRoute();
const { t: $t } = useI18n();
const props = defineProps<{
  articleDisplayResults: unknown[];
  selectSearchRow: unknown;
  searchPhrases: string | unknown[];
  actPage: number;
  lastPage: boolean;
  loading: boolean;
  language: string;
  highlightArticleId: string | null;
}>();
const emits = defineEmits(["selected", "navigate-next", "navigate-previous"]);
//#endregion

//#region Ref
const searchResultsDisplay = ref();
//#endregion

//#region Methods
const selected = (args: any) => {
  //Event for parent when selection is changed
  emits("selected", args);
};

const refreshSelectionByUrlId = () => {
  const indexOfCurrentArticle = _.findIndex(props.articleDisplayResults, {
    articleId: $route?.params?.id
  });
  searchResultsDisplay.value.clearSelected();
  if (indexOfCurrentArticle != -1) {
    searchResultsDisplay.value.selectRow(indexOfCurrentArticle);
  }
};
//#endregion

//#region Computed
const fields = computed(() => {
  return [
    {
      key: "index",
      label: "",
      sortable: false,
      tdClass: "d-none "
    },
    {
      key: "articleNo",
      label: "",
      sortable: false,
      tdClass: "d-none"
    },
    {
      key: "displaytext",
      label: "",
      sortable: false,
      tdClass: "p-0 simple-search-result-cell",

      escape: false
    }
  ];
});
//#endregion

//#region Watch
watch(
  () => props.selectSearchRow,
  () => {
    refreshSelectionByUrlId();
  }
);

watch(
  () => props.articleDisplayResults,
  () => {
    searchResultsDisplay.value.clearSelected();
    searchResultsDisplay.value.refresh();
  }
);

//#endregion

//#region LifeCycle
onMounted(() => {
  refreshSelectionByUrlId();
});
//#endregion
</script>
